<template>
  <div class="fav-wrapper">
    <div class="favorite-container">
      <div>
        <div
          v-if="this.newTripPopup && this.index === 0 && objectid != ''"
          class="popup-favorite-wrapper"
        >
          <span class="popup-favorite-text"
            >Now you can use the favorite to save it to your trip</span
          >
          <OverlaySignedInWithTrip
            :slug="slug"
            :objectid="objectid"
            :signInWithTripsMap="signInWithTripsMap"
          />
          <b-button
            v-if="objectid != ''"
            @click="toggleFavorite"
            :variant="
              this.getFavorites(objectid) && showONSI == false
                ? 'light btn-fav-remove icon-map-minus'
                : 'light btn-fav-add-inverted icon-map-plus'
            "
            class="favorite-icon popup-favorite-icon"
          >
          </b-button>
        </div>
        <b-button
          v-else
          @click="toggleFavorite"
          :variant="
            this.getFavorites(objectid) && showONSI == false
              ? 'light btn-fav-remove icon-map-minus'
              : 'light btn-fav-add icon-map-plus'
          "
          class="favorite-icon"
        >
        </b-button>
      </div>
    </div>
    <div
      v-if="showONSI"
      :class="{
        addFromCarousel:
          isCity ||
          isArea ||
          (isCarousel && isAttraction) ||
          (isCarousel && isEvent) ||
          (isCarousel && isUpcomingEvent),
      }"
    >
      <OverlayNotSignedIn
        :objectid="`${parent}-${objectid}`"
        :notSignedInMap="notSignedInMap"
      />
    </div>
    <div
      v-if="showOSINT && !hasTrips"
      :class="{
        addFromCarousel:
          isCity ||
          isArea ||
          (isCarousel && isAttraction) ||
          (isCarousel && isEvent) ||
          (isCarousel && isUpcomingEvent),
      }"
    >
      <OverlaySignedInNoTrip
        :slug="slug"
        :objectid="objectid"
        :signInWithNoTripsMap="signInWithNoTripsMap"
      />
    </div>
    <div
      v-if="showOSIWT && hasTrips"
      :class="{
        addFromCarousel:
          isCity ||
          isArea ||
          (isCarousel && isAttraction) ||
          (isCarousel && isEvent) ||
          (isCarousel && isUpcomingEvent),
      }"
    >
      <OverlaySignedInWithTrip
        :slug="slug"
        :objectid="objectid"
        :signInWithTripsMap="signInWithTripsMap"
      />
    </div>
    <!-- Login Modal (Favorites) -->
    <b-modal
      :id="`${parent}-${objectid}`"
      ref="login-modal-favorite"
      hide-header
      hide-footer
      hide-backdrop
      scrollable
      no-close-on-backdrop
    >
      <span @click="hideModal" class="icon-close modal-icon-close"></span>
      <sign-in
        :isLoggedIn="isLoggedIn"
        :objectid="objectid"
        v-if="showSignInModal"
      ></sign-in>
      <sign-up
        v-if="showSignUpModal"
      ></sign-up>
      <forgot-password v-if="showForgotPasswordModal"></forgot-password>
      <confirmation
        :myEmail="newUserEmail"
        v-if="showConfirmationModal"
        v-on:sign-up-email="assignEmail"
      >
      </confirmation>
      <forgot-password-confirmation-modal
        :myEmail="newUserEmail"
        v-if="showForgotPasswordConfirmationModal"
        v-on:sign-up-email="assignEmail"
      ></forgot-password-confirmation-modal>
    </b-modal>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import { mapActions, mapGetters } from 'vuex';
import Confirmation from '../../views/ConfirmationModal.vue';
import ForgotPasswordConfirmationModal from '../../views/ForgotPasswordConfirmationModal.vue';
import ForgotPassword from '../../views/ForgotPasswordModal.vue';
import SignIn from '../../views/LoginModal.vue';
import OverlayNotSignedIn from '../../views/OverlayNotSignedIn.vue';
import OverlaySignedInNoTrip from '../../views/OverlaySignedInNoTrip.vue';
import OverlaySignedInWithTrip from '../../views/OverlaySignedInWithTrip.vue';
import SignUp from '../../views/SignUpModal.vue';

export default {
  props: {
    objectid: {
      type: String,
    },
    slug: {
      type: String,
    },
    isCarousel: {
      type: Boolean,
    },
    index: {
      type: Number,
      default: null,
    },
    notSignedInMap: {
      type: Boolean,
    },
    signInWithNoTripsMap: {
      type: Boolean,
    },
    signInWithTripsMap: {
      type: Boolean,
    },
    parent: {
      type: String,
    },
  },
  data() {
    return {
      showInRoute: true,
      setFavLocPin: false,
      showONSI: false,
      showOSINT: false,
      showOSIWT: false,
      showSignInModal: false,
      showSignUpModal: false,
      showForgotPasswordModal: false,
      showConfirmationModal: false,
      showForgotPasswordConfirmationModal: false,
      newUserEmail: null,
      isLoggedIn: false,
      numOfLocations: 0,
      isCity: this.$route.name === 'city',
      isArea: this.$route.name === 'area',
      isUpcomingEvent: this.$route.name === 'upcoming events',
      isEvent: this.$route.name === 'festivals and events',
      isAttraction: this.$route.name === 'attraction',
      trips: [],
    };
  },
  async created() {
    this.$root.$on('hideONSI', (value) => {
      this.showONSI = value;
    });
    this.$root.$on('hideOSIWT', (value) => {
      this.showOSIWT = value;
    });
    this.$root.$on('afterSignIn', (value) => {
      this.$props.myTrips = value;
      this.$root.$emit('toggleCarouselInterval', 5000);
    });
    this.$root.$on('hideOSINT', (value) => {
      this.showOSINT = value;
    });
    this.$root.$on('hideLoginModalFavorite', () => {
      this.$refs['login-modal-favorite'].hide();
      this.$root.$emit('toggleCarouselInterval', 5000);
    });
    this.$root.$on('showFP', () => {
      this.handleModalViews('fp');
    });
    this.$root.$on('showCM', () => {
      this.handleModalViews('cm');
    });
    this.$root.$on('showSU', () => {
      this.handleModalViews('su');
    });
    this.$root.$on('showSIinUserFavorite', () => {
      this.handleModalViews('si');
    });
    this.$root.$on('showFPC', () => {
      this.handleModalViews('fpc');
    });
    this.$root.$on('showONSI', () => {
      this.handleModalViews('onsi');
    });
    this.$root.$on('showOSINT', () => {
      this.handleModalViews('osint');
    });
    this.$root.$on('showOSIWT', () => {
      this.handleModalViews('osiwt');
    });
    this.$root.$on('sign-up-email', (myEmail) => {
      this.newUserEmail = myEmail;
    });
  },

  methods: {
    ...mapActions({
      loadMyTrips: 'myTrips/loadMyTrips',
      dismissPopup: 'myTrips/dismissPopup',
    }),
    async toggleFavorite() {
      this.dismissPopup();
      try {
        const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
        // If user has NO trips
        // set showOSINT variable to true and show popup
        if (user && !this.hasTrips) {
          this.showOSINT = true;
        }
        // If user has trips
        // set showOSIWT variable to true and show popup
        if (user && this.hasTrips) {
          this.showOSIWT = true;
        }
      } catch (error) {
        this.isLoggedIn = true;
        // User NOT signed in
        this.showONSI = true;
      }
    },
    handleModalViews(value) {
      // Show OverlayNotSignedInModal
      if (value === 'onsi') {
        this.showSignInModal = false;
        this.showSignUpModal = false;
        this.showForgotPasswordModal = false;
        this.showConfirmationModal = false;
        this.showForgotPasswordConfirmationModal = false;
      }
      // Show OverlaySignedInNoTripModal
      if (value === 'osint') {
        this.showSignInModal = false;
        this.showSignUpModal = false;
        this.showForgotPasswordModal = false;
        this.showConfirmationModal = false;
        this.showForgotPasswordConfirmationModal = false;
      }
      // Show OverlaySignedInWithTripModal
      if (value === 'osiwt') {
        this.showSignInModal = false;
        this.showSignUpModal = false;
        this.showForgotPasswordModal = false;
        this.showConfirmationModal = false;
        this.showForgotPasswordConfirmationModal = false;
      }
      // Show SignInModal
      if (value === 'si') {
        this.showSignInModal = true;
        this.showSignUpModal = false;
        this.showForgotPasswordModal = false;
        this.showConfirmationModal = false;
        this.showForgotPasswordConfirmationModal = false;
      }
      // Show SignUpModal
      if (value === 'su') {
        this.showSignInModal = false;
        this.showSignUpModal = true;
        this.showForgotPasswordModal = false;
        this.showConfirmationModal = false;
        this.showForgotPasswordConfirmationModal = false;
      }
      // Show ForgotPasswordModal
      if (value === 'fp') {
        this.showSignInModal = false;
        this.showSignUpModal = false;
        this.showForgotPasswordModal = true;
        this.showConfirmationModal = false;
        this.showForgotPasswordConfirmationModal = false;
      }
      // Show ConfirmationModal
      if (value === 'cm') {
        this.showSignInModal = false;
        this.showSignUpModal = false;
        this.showForgotPasswordModal = false;
        this.showConfirmationModal = true;
        this.showForgotPasswordConfirmationModal = false;
      }
      // Show ForgetPasswordConfirmationModal
      if (value === 'fpc') {
        this.showSignInModal = false;
        this.showSignUpModal = false;
        this.showForgotPasswordModal = false;
        this.showConfirmationModal = false;
        this.showForgotPasswordConfirmationModal = true;
      }
    },
    hideModal() {
      this.$refs['login-modal-favorite'].hide();
      this.$root.$emit('toggleCarouselInterval', 5000);
    },
  },
  components: {
    SignIn,
    SignUp,
    Confirmation,
    ForgotPassword,
    ForgotPasswordConfirmationModal,
    OverlayNotSignedIn,
    OverlaySignedInNoTrip,
    OverlaySignedInWithTrip,
  },
  computed: {
    ...mapGetters({
      hasTrips: 'myTrips/hasTrips',
      newTripPopup: 'myTrips/newTripPopup',
      myTrips: 'myTrips/myTrips',
      myTripsLoaded: 'myTrips/loaded',
      getFavorites: 'myTrips/getFavorites',
    }),
  },
};
</script>
<style scoped>
.hideModal {
  position: relative;
  left: 90%;
  /* position: fixed;
  left: 95%; */
  color: var(--dark-blue-300);
  font-size: 50px;
  cursor: pointer;
}

.fav-wrapper {
  position: absolute;
  top: 10px;
  left: -10px;
}

.favorite-container {
  display: grid;
  grid-template-areas:
    'show-in-route-tx favorite-icon'
    'show-in-route-toggle .';
}

.show-in-route-tx {
  grid-area: 'show-in-route-tx';
  font-family: 'IdealSans-Bold';
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: var(--dark-blue-300);
}

.show-in-route-toggle {
  grid-area: 'show-in-route-toggle';
  margin-left: 40px;
  padding-left: 60px;
}

.favorite-icon {
  grid-area: 'favorite-icon';
}

.addFromCarousel {
  position: relative;
  left: 230px;
}

.toggle-route-hidden {
  display: none;
}

.popup-favorite-wrapper {
  background-color: #173945;
  border-radius: 20px;
  border: none;
  width: 237px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 20px 8px;
  position: absolute;
  top: 25px;
  right: -32px;
  height: 40px;
  gap: 5px;
}

.popup-favorite-text {
  font-size: 12px;
  font-weight: 350;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  color: #d9dadb;
  width: 169px;
  height: 28px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.popup-favorite-icon {
  height: 36px;
  width: 36px;
  background-color: #173945;
  border: none;
  flex: none;
  order: 1;
  flex-grow: 0;
  left: 0;
  margin-right: 4px;
}
</style>
